// extracted by mini-css-extract-plugin
export default {"confirmationModal":"NewVersionPopup_confirmationModal__H-4jd","confirmationModalActions":"NewVersionPopup_confirmationModalActions__Ntmf9"};